import {
  EditFormStoreEvent,
  EditFormStoreEventKind,
  EditFormStoreRowClickEvent,
  EditFormStoreSetHighlightedRowsEvent,
  EditFormStoreSetupButtonClickEvent,
  EditFormStoreToggleSettingsDrawerEvent,
} from 'config/pbEvents';
import { PubSub } from 'stores/common/PubSub';
import { ILocalStore } from 'stores/interfaces';

/** Посредник по передаче событий между сторами EditFormStore и FieldSettingsStore */
class EditFormStoreMediator implements ILocalStore {
  private readonly _pubSub = new PubSub<EditFormStoreEvent>();

  subscribeToRowClickEvent(
    callback: (payload: EditFormStoreEvent) => void
  ): VoidFunction {
    return this._pubSub.subscribe(EditFormStoreEventKind.ROW_CLICK, callback);
  }

  subscribeToSetupButtonClickEvent(
    callback: (payload: EditFormStoreEvent) => void
  ): VoidFunction {
    return this._pubSub.subscribe(
      EditFormStoreEventKind.SETUP_BUTTON_CLICK,
      callback
    );
  }

  subscribeToSetHighlightedRowsEvent(
    callback: (payload: EditFormStoreEvent) => void
  ): VoidFunction {
    return this._pubSub.subscribe(
      EditFormStoreEventKind.SET_HIGHLIGHTED_ROWS,
      callback
    );
  }

  subscribeToToggleSettingsDrawerEvent(
    callback: (payload: EditFormStoreEvent) => void
  ): VoidFunction {
    return this._pubSub.subscribe(
      EditFormStoreEventKind.TOGGLE_SETTINGS_DRAWER,
      callback
    );
  }

  emitRowClickEvent(payload: EditFormStoreRowClickEvent['payload']): void {
    this._pubSub.publish({
      kind: EditFormStoreEventKind.ROW_CLICK,
      payload,
    });
  }

  emitSetupButtonClickEvent(
    payload: EditFormStoreSetupButtonClickEvent['payload']
  ): void {
    this._pubSub.publish({
      kind: EditFormStoreEventKind.SETUP_BUTTON_CLICK,
      payload,
    });
  }

  emitSetHighlightedRowsEvent(
    payload: EditFormStoreSetHighlightedRowsEvent['payload']
  ): void {
    this._pubSub.publish({
      kind: EditFormStoreEventKind.SET_HIGHLIGHTED_ROWS,
      payload,
    });
  }

  emitToggleSettingsDrawerEvent(
    payload: EditFormStoreToggleSettingsDrawerEvent['payload']
  ): void {
    this._pubSub.publish({
      kind: EditFormStoreEventKind.TOGGLE_SETTINGS_DRAWER,
      payload,
    });
  }

  destroy(): void {
    this._pubSub.destroy();
  }
}

export { EditFormStoreMediator };
